export const PAGES_HEAD_CONTENT = {
  MAIN: {
    title: 'Customers.ai | Sales Automation & Prospecting Data Platform',
    meta: {
      description: `
        With Customers.ai, you can create chatbots for free without writing a single line of code.
        Your engagement rate is about to go bananas.
      `,
    },
  },
  LOGIN: {
    title: 'Customers.ai Login',
    meta: {
      description: `
        Welcome back to Customers.ai! Ready to build more chatbots?
        Log in to your account with your email address or your Facebook account.
      `,
    },
  },
  SIGNUP: {
    title: 'Sign Up for Customers.ai',
    meta: {
      description: `
        Welcome to our coding-free chatbot builder!
        Sign up for a Customers.ai account and start creating Facebook Messenger chatbots today.
      `,
    },
  },
  AUTOMATIONS: {
    title: 'Customers.ai | Automations',
    meta: { description: 'Customers.ai | Automations' },
  },
};

export default PAGES_HEAD_CONTENT;
